export default (value) => {
  return new Intl.NumberFormat('en-us').format(parseInt(value))
}